// action types
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_SPINNER = 'SET_SPINNER';
export const REMOVE_SPINNER = 'REMOVE_SPINNER';
export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS';